import { FC } from "react";
import { GiftcardItem, SelectedGiftcard } from "src/store/slices/item/subitems/giftcards.types";
import { Instructions } from "../components";
import GiftcardDetailsCardNew from "../components/GiftcardDetailsCard/GiftcardDetailsCard";
import GiftcardChips from "../components/GiftcardChips/GiftcardChips";
import GiftcardRangeSelector from "../components/GiftcardRangeSelector/GiftcardRangeSelector";
import GiftcardRedeemBar from "../components/GiftcardRedeemBar/GiftcardRedeemBar";
import { Divider } from "antd";

type Props = {
  data: SelectedGiftcard | undefined;
  imageUrl: string | undefined;
  itemCode: string;
  items: GiftcardItem[];
  selectedItemIndex: number;
  setSelectedItemIndex: (i: number) => void;
  brandName?: string;
  range?: { min: number; max: number; value: number };
  onRangeChange: (value: number) => void;
};

const GiftcardDetailsWeb: FC<Props> = ({
  data,
  imageUrl,
  itemCode,
  items,
  selectedItemIndex,
  setSelectedItemIndex,
  brandName,
  range,
  onRangeChange,
}) => {
  return (
    <div className="flex w-full gap-10">
      <div className="flex-5 flex flex-col gap-6">
        <div className="rounded-xs flex flex-col gap-6 p-6 shadow-sm">
          <div className="flex flex-col gap-4">
            <GiftcardDetailsCardNew data={data} imageUrl={imageUrl} brandName={brandName} />
            <GiftcardChips items={items} selectedItemIndex={selectedItemIndex} onSelect={setSelectedItemIndex} />
            {range && (
              <GiftcardRangeSelector min={range.min} max={range.max} value={range.value} currency={data?.currency} onChange={onRangeChange} />
            )}
          </div>
          <Divider className="m-0!"/>
          <div>
            <GiftcardRedeemBar data={data} imageUrl={imageUrl} itemCode={itemCode} />
          </div>
        </div>
      </div>
      <div className="flex-2 rounded-xs shadow-sm">
        <Instructions termsAndConditions={data?.termsAndConditions ?? ""} usageInstructions={data?.usageInstructions ?? ""} />
      </div>
    </div>
  );
};

export default GiftcardDetailsWeb;
